<!-- <div id="details" *ngIf="detailStore.firstDetail | async as detail">
<form>
  <mat-form-field>
    <input matInput readonly placeholder="Version:" value="{{detail.version}}">
  </mat-form-field>
  <mat-form-field>
    <input matInput readonly placeholder="Description:" value="{{detail.description}}">
  </mat-form-field>
  <mat-form-field>
    <input matInput readonly placeholder="Created Date:" value="{{detail.createdDate}}">
  </mat-form-field>
  <mat-form-field>
    <input matInput readonly placeholder="Modified Date:" value="{{detail.modifiedDate}}">
  </mat-form-field>
  <mat-form-field>
    <input matInput readonly placeholder="Created By:" value="{{detail.createdBy}}">
  </mat-form-field>
  <mat-form-field>
    <input matInput readonly placeholder="Modified By:" value="{{detail.modifiedBy}}">
  </mat-form-field>
</form>
</div> -->

@if (organization) {
<div id="Authentication" style="max-width: 98%">
  <div style="padding-bottom: 20px"></div>
  <form (ngSubmit)="onSubmit()" [formGroup]="organizationForm" style="background-color: white; padding: 5px">
    <div style="padding-top: 10px">
      <mat-checkbox name="allowLocalLogin" formControlName="allowLocalLogin" labelPosition="before">Do not allow local login users (except for admin accounts)</mat-checkbox>
    </div>
    <div style="padding-top: 10px">
      <mat-checkbox name="allowThirdPartyLogin" formControlName="allowThirdPartyLogin" labelPosition="before">Enable Single Sign On</mat-checkbox>
    </div>
    <div style="max-width: 400px; padding-top: 10px">
      <mat-form-field>
        <mat-label>Select Single Sign On Provider</mat-label>
        <mat-select formControlName="thirdPartyLoginProvider" name="ssoProviders">
          @for (ssoProvider of ssoProviders; track ssoProvider) {
          <mat-option [value]="ssoProvider">
            {{ ssoProvider }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <button mat-raised-button color="primary" type="submit" [disabled]="!organizationForm.dirty">Save</button>
  </form>
</div>
}
